import { currentShippingAddressStyles } from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress";
import { css } from "styled-components";

Object.assign(currentShippingAddressStyles, {
    ...currentShippingAddressStyles,
    headingText: {
        variant: "h3",
        css: css`
            width: 100%;
            font-size: 22px;
            padding-bottom: 2px;
            margin: 0;
            color: #252525;
            border-bottom: none;
            text-transform: none;
        `,
    },
});
